module.exports = __webpack_public_path__ + "header-profile-skin-3.bf471ec3d4085883e061.png";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/css/patterns/header-profile-skin-3.png
// module id = ../../../../../ng-src/assets/css/patterns/header-profile-skin-3.png
// module chunks = styles